export interface IUIConfigUserConfig {
  hidden: boolean;
  disabled: boolean;
}

export enum EN_UI_CONFIG_NAMESPACE {
  // 方案弹窗
  DESIGN_MODAL = 'design.modal',
  // 项目资源配置
  PROJECT_RESOURCE = 'project.resource',
  // 项目资源子配置
  PROJECT_RESOURCE_CHILDREN = 'project.resource.children',
}

export enum EN_DESIGN_MODAL_CONFIG {
  所属团队 = '所属团队',
  所属项目 = '所属项目',
  方案名称 = '方案名称',
  方案类型 = '方案类型',
  设计类型 = '设计类型',
  方案格式 = '方案格式',
  方案数量 = '方案数量',
  设计基准 = '设计基准',
  设备状态 = '设备状态',
}
export enum EN_PROJECT_RESOURCE_CONFIG {
  图框布局 = '图框布局',
  标注 = '标注',
  公差 = '公差',
  表格 = '表格',
  文字 = '文字',
  索引 = '索引',
  百格线 = '百格线',
  焊接件 = '焊接件',
  打开状态利旧 = '打开状态&利旧',
  形位公差 = '形位公差',
  配合公差 = '配合公差',
  形位公差Beta = '形位公差-beta',
  形位公差上海电气 = '形位公差-上海电气',
  检测基准 = '检测基准',
}
export enum EN_PROJECT_RESOURCE_CHILDREN_CONFIG {
  型面标注 = '型面标注',
  定位销标注 = '定位销标注',
  零件自动孔位图 = '零件自动孔位图',
}

export const UI_CONFIG = {
  [EN_UI_CONFIG_NAMESPACE.DESIGN_MODAL]: Object.values(EN_DESIGN_MODAL_CONFIG),
  [EN_UI_CONFIG_NAMESPACE.PROJECT_RESOURCE]: Object.values(EN_PROJECT_RESOURCE_CONFIG),
  [EN_UI_CONFIG_NAMESPACE.PROJECT_RESOURCE_CHILDREN]: Object.values(
    EN_PROJECT_RESOURCE_CHILDREN_CONFIG
  ),
};

export type UIConfigKeys<T extends EN_UI_CONFIG_NAMESPACE> = (typeof UI_CONFIG)[T][number];
